export default __webpack_public_path__ + "static/Brandon-Regular-400-7b5f4589eae82e15cc76391d4e07cf55.woff";